/* eslint-disable */ 
import React from 'react' ;
import { Images } from '../../Common/Images';

export default function Avatar(props) {
    return (
        <img style={props.style || {borderRadius:50, backgroundColor:"#ddd", height:100, width:100}} src={props.src || Images.plage} alt={props.alt ? props.alt : 'profil'}/>
    )
}